/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateAccessTokenGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type CreateAccessTokenResponse = {
  headers: { [k: string]: Array<string> };
  result: components.AuthToken;
};

/** @internal */
export const CreateAccessTokenGlobals$inboundSchema: z.ZodType<
  CreateAccessTokenGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type CreateAccessTokenGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const CreateAccessTokenGlobals$outboundSchema: z.ZodType<
  CreateAccessTokenGlobals$Outbound,
  z.ZodTypeDef,
  CreateAccessTokenGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function createAccessTokenGlobalsToJSON(
  createAccessTokenGlobals: CreateAccessTokenGlobals,
): string {
  return JSON.stringify(
    CreateAccessTokenGlobals$outboundSchema.parse(createAccessTokenGlobals),
  );
}
export function createAccessTokenGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<CreateAccessTokenGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateAccessTokenGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateAccessTokenGlobals' from JSON`,
  );
}

/** @internal */
export const CreateAccessTokenResponse$inboundSchema: z.ZodType<
  CreateAccessTokenResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: components.AuthToken$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type CreateAccessTokenResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: components.AuthToken$Outbound;
};

/** @internal */
export const CreateAccessTokenResponse$outboundSchema: z.ZodType<
  CreateAccessTokenResponse$Outbound,
  z.ZodTypeDef,
  CreateAccessTokenResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: components.AuthToken$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function createAccessTokenResponseToJSON(
  createAccessTokenResponse: CreateAccessTokenResponse,
): string {
  return JSON.stringify(
    CreateAccessTokenResponse$outboundSchema.parse(createAccessTokenResponse),
  );
}
export function createAccessTokenResponseFromJSON(
  jsonString: string,
): SafeParseResult<CreateAccessTokenResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateAccessTokenResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateAccessTokenResponse' from JSON`,
  );
}
